// cspell:disable

const languageCodes = ["en", "fr"] as const;
type TosTranslations = { [key in (typeof languageCodes)[number]]: Translation };

interface Translation {
  byPurchasing: string;
  privacyPolicy: string;
  and: string;
  termsAndConditions: string;
  shippingProtectionProvidedBy: string;
  coverageIsSubjectToMerchantReturnPolicy: string;
}

export const translations: TosTranslations = {
  en: {
    byPurchasing: "By purchasing coverage, you agree and have read the",
    privacyPolicy: "Privacy Policy",
    and: "and",
    termsAndConditions: "Terms and Conditions",
    coverageIsSubjectToMerchantReturnPolicy:
      "Coverage is subject to Merchant's Return Policy.",
    shippingProtectionProvidedBy: "Shipping protection provided by",
  },
  fr: {
    byPurchasing: "En achetant une protection, vous acceptez et avez lu le",
    privacyPolicy: "Politique de confidentialité",
    and: "et",
    termsAndConditions: "Conditions d'utilisation",
    coverageIsSubjectToMerchantReturnPolicy:
      "La couverture est soumise à la politique de retour du marchand.",
    shippingProtectionProvidedBy: "Protection de livraison fournie par",
  },
};
